import React from 'react'

class AboutDe extends React.Component {
  render() {
    return <div>
      <h2>Über die Datenbank</h2>

      <p><strong>SenLex-Datenbank</strong><strong>&nbsp;ist eine Sammlung amtlicher Auskünften bezüglich sämtlicher belgischen Institutionsregeln. Die Datenbank hat für Sie die Verfassung und die wichtigsten institutionellen Normen gesammelt und je Artikel sortiert, aussagekräftige Auszüge aus der parlamentarischen Vorbereitung, der Rechtsprechung des Verfassungsgerichts und Gutachten des Staatsrates aufgeführt</strong>.</p>

      <p>Das belgische institutionelle Regelwerk umfasst <strong>die Verfassung, die besonderen Mehrheitsgesetze und einige ordentliche </strong>Gesetze.</p>

      <p>Wer die genaue Tragweite dieses Regelwerkes erfahren möchte, dem reicht jedoch selten der reine Gesetzestext. Der Inhalt der institutionellen Gesetzestexte wird in erheblichem Maße von deren Vorbereitung im Parlament, den Beschlüssen des Verfassungsgerichtshofes sowie den Gutachten und Beschlüssen des Staatsrates bestimmt. Es sind besonders viele offizielle Informationen über das institutionelle Regelwerk vorhanden. Diese Informationen sind hingegen stark verstreut und nicht sehr übersichtlich. Senlex bündelt die amtlichen Informationen aus <strong>der Vorbereitung im Parlament, den Entscheidungen des Verfassungsgerichtshofes sowie den Gutachten und Entscheidungen des Staatsrates</strong>.</p>

      <p>Diese Informationen oder Daten werden artikelweise oder bei Bedarf nach Artikelabschnitten strukturiert. Für jeden Artikel werden die einschlägigen Informationen in folgende Rubriken aufgeschlüsselt:</p>

      <ul>
        <li>der Gesetzestext</li>
        <li>Suchbegriffe</li>
        <li>Anmerkungen:
          <ul>
            <li>Vorgeschichte des Gesetze</li>
            <li>die parlamentarische Vorbereitung</li>
            <li>die Rechtsprechung und die Gutachten</li>
            <li>die Erläuterungen</li>
            <li>die Verweise auf andere Artikel</li>
          </ul>
        </li>
      </ul>

      <p>In den Rubriken „parlamentarische Vorbereitung“ und „Rechtsprechung und Gutachten“ finden Sie nicht allein <strong><em>Hyperlinks</em></strong> zu den betreffenden Dokumenten vor, sondern werden die betreffenden Fragmente aus diesen Dokumenten zudem <strong>vollständig</strong> übernommen. Sie brauchen in diesen Dokumenten nicht selber die den Artikel betreffenden Textabschnitte zu suchen. Senlex bietet diese Fragmente automatisch <em>in ihrer ausführlichen Fassung</em>.</p>

      <p>Über die <a href="/de">Homepage </a>haben Sie direkten Zugang zu den einzelnen Texte mit Anmerkungen oder können Sie mit der Suchfunktion anhand von Suchbegriffen oder Stichwörtern ihre Suche beginnen.</p>

      <p>Senlex bündelt die amtlichen Informationen, die <strong>seit dem 1. Juli 2014 </strong>veröffentlicht wurden. Senlex umfasst des Weiteren die vollständige parlamentarische Vorbereitung der Sechsten Staatsreform, die bereits vor diesem Datum veröffentlicht wurde. Ausnahmsweise sind auch ältere Texte vorzufinden.</p>

      <p>Die Senlex-Datenbank wird von den Dienststellen des Senates zusammengestellt. Die Datenbank hat rein informativen Wert. Die Datenbank wurde mit äußerster Sorgfalt zusammengestellt, doch können weder der Senat noch dessen Dienststellen für den Inhalt der Datenbank haftbar gemacht werden. Weitere diesbezügliche Informationen finden Sie in der <a href="/de/disclaimer">Haftungsausschlusserklärung</a></p>
    </div>
  }
}



export default AboutDe;



/** WEBPACK FOOTER **
 ** ./src/modules/helptexts/about/de.js
 **/